import 'bootstrap/dist/css/bootstrap.min.css'
import './layout.css'

import Layout from './layout'

export default Layout
